/**
 * Chapitre & Café - "Le Mug Pile de Livres" page (prefix cc-).
 *
 * Offer: one product, 3 model variants. An edition adds 1/2/3 units of the
 * chosen model; Shopify automatic discounts (once per order) make 2 mugs
 * 41,90 and 3 mugs 54,90. The page shows unit price x qty - the edition's
 * "Réduction" setting, which must equal that discount.
 *
 * The cart drawer is always drawn from /cart.js, so it shows what checkout
 * charges. Every cart change dispatches the theme's CartLinesUpdateEvent
 * (04-traps.md D8). type="module": runs once per page.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const dataEl = document.getElementById('cc-data');
const DATA = dataEl ? JSON.parse(dataEl.textContent) : null;
const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

let nf;
function fmt(cents) {
  if (!nf) {
    try { nf = new Intl.NumberFormat((DATA && DATA.locale) || 'fr-FR', { style: 'currency', currency: (DATA && DATA.currency) || 'EUR' }); }
    catch (e) { nf = { format: (n) => n.toFixed(2).replace('.', ',') + ' €' }; }
  }
  return nf.format((Number(cents) || 0) / 100);
}
function fill(tpl, map) { return Object.keys(map).reduce((s, k) => s.split('[' + k + ']').join(map[k]), tpl || ''); }
function route(path) { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + path; }

/* ====================== State ====================== */
const state = { variant: null, bundle: DATA ? DATA.defaultBundle : 0 };
if (DATA) {
  const activeTile = $('.cc-tile.is-active');
  const id = activeTile ? Number(activeTile.getAttribute('data-cc-variant')) : 0;
  state.variant = DATA.variants.find((v) => v.id === id) || DATA.variants.find((v) => v.available) || DATA.variants[0];
}
// A % edition (English market, converted currencies) comes off each unit
// rounded down to the cent, exactly like Shopify's percentage discount.
function bundlePrice(b, v) { return b.pct > 0 ? (v.price - Math.floor(v.price * b.pct / 100)) * b.qty : v.price * b.qty - b.reduction; }
function bundleCompare(b, v) { return v.compare * b.qty; }
function bundleForQty(q) { return DATA.bundles.find((b) => b.qty === q) || null; }
function priceForQty(q, v) { const b = bundleForQty(q); return b ? bundlePrice(b, v) : v.price * q; }
function variantById(id) { return DATA ? DATA.variants.find((v) => v.id === id) : null; }

/* ====================== Gallery ====================== */
const gallery = $('[data-cc-gallery]');
const slides = $$('[data-cc-slide]');
const vslides = $$('[data-cc-vslide]');
const thumbs = $$('[data-cc-thumb]');
const vthumbs = $$('[data-cc-vthumb]');
let imgIndex = 0;

function activate(img, thumb) {
  slides.concat(vslides).forEach((s) => s.classList.toggle('is-active', s === img));
  thumbs.concat(vthumbs).forEach((t) => t.classList.toggle('is-active', t === thumb));
  if (thumb) {
    const row = thumb.parentElement;
    const left = thumb.offsetLeft - row.offsetLeft;
    if (left < row.scrollLeft || left + thumb.offsetWidth > row.scrollLeft + row.clientWidth) {
      row.scrollTo({ left: left - row.clientWidth / 2 + thumb.offsetWidth / 2, behavior: 'smooth' });
    }
  }
}
function showPhoto(i) {
  if (!slides.length) return;
  imgIndex = (i + slides.length) % slides.length;
  const img = slides[imgIndex];
  activate(img, thumbs[imgIndex]);
  const counter = $('[data-cc-counter]'); if (counter) counter.textContent = (imgIndex + 1) + ' / ' + slides.length;
  const cap = $('[data-cc-caption]'); if (cap) cap.textContent = 'Fig. ' + (imgIndex + 1) + ' — ' + (img.getAttribute('data-caption') || '');
}
function showVariantPhoto(v) {
  const img = vslides.find((s) => Number(s.getAttribute('data-cc-vslide')) === v.id);
  if (!img) return;
  activate(img, vthumbs.find((t) => Number(t.getAttribute('data-cc-vthumb')) === v.id));
  const counter = $('[data-cc-counter]'); if (counter) counter.textContent = DATA.modelWord + ' ' + v.letter;
  const cap = $('[data-cc-caption]'); if (cap) cap.textContent = 'Fig. ' + v.letter + ' — ' + (v.desc || (DATA.modelWord + ' ' + v.letter + ' — ' + v.name));
}
thumbs.forEach((t) => t.addEventListener('click', () => showPhoto(Number(t.getAttribute('data-cc-thumb')))));
vthumbs.forEach((t) => t.addEventListener('click', () => selectVariant(Number(t.getAttribute('data-cc-vthumb')))));
$$('[data-cc-prev]').forEach((b) => b.addEventListener('click', () => showPhoto(imgIndex - 1)));
$$('[data-cc-next]').forEach((b) => b.addEventListener('click', () => showPhoto(imgIndex + 1)));

/* ====================== Models + editions ====================== */
function render() {
  if (!DATA) return;
  const v = state.variant;
  $$('[data-cc-variant]').forEach((t) => {
    const on = Number(t.getAttribute('data-cc-variant')) === v.id;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-checked', on ? 'true' : 'false');
  });
  const vn = $('[data-cc-variant-name]'); if (vn) vn.textContent = v.letter + ' — ' + v.name;
  $$('[data-cc-bundle]').forEach((row) => {
    const i = Number(row.getAttribute('data-cc-bundle'));
    const b = DATA.bundles[i];
    const on = i === state.bundle;
    row.classList.toggle('is-active', on);
    row.setAttribute('aria-checked', on ? 'true' : 'false');
    $('.cc-check', row).textContent = on ? '✕' : '';
    if (!b) return;
    const p = bundlePrice(b, v), c = bundleCompare(b, v);
    const pe = $('[data-cc-b-price]', row); if (pe) pe.textContent = fmt(p);
    const ce = $('[data-cc-b-was]', row); if (ce) ce.textContent = fmt(c);
  });
  const b = DATA.bundles[state.bundle];
  const label = $('[data-cc-sticky-label]');
  if (label && b) label.textContent = DATA.modelWord + ' ' + v.letter + ' · ' + b.title;
  const sp = $('[data-cc-sticky-price]'); if (sp && b) sp.textContent = fmt(bundlePrice(b, v));
  const sw = $('[data-cc-sticky-was]'); if (sw && b) sw.textContent = bundleCompare(b, v) > bundlePrice(b, v) ? fmt(bundleCompare(b, v)) : '';
}
function selectVariant(id) {
  const v = variantById(id);
  if (!v) return;
  state.variant = v;
  showVariantPhoto(v);
  render();
  try {
    const url = new URL(location.href);
    url.searchParams.set('variant', String(v.id));
    history.replaceState(history.state, '', url.toString());
  } catch (e) { /* old browser - harmless */ }
}
$$('[data-cc-variant]').forEach((t) => t.addEventListener('click', () => selectVariant(Number(t.getAttribute('data-cc-variant')))));
$$('[data-cc-bundle]').forEach((row) => row.addEventListener('click', () => {
  state.bundle = Number(row.getAttribute('data-cc-bundle'));
  render();
}));

/* ====================== Accordions (one open per group) ====================== */
$$('[data-cc-acc]').forEach((group) => {
  const btns = $$('[data-cc-acc-btn]', group);
  btns.forEach((btn) => btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') === 'true';
    btns.forEach((o) => {
      o.setAttribute('aria-expanded', 'false');
      $('.cc-acc-icon', o).textContent = '+';
      document.getElementById(o.getAttribute('aria-controls')).hidden = true;
    });
    if (!open) {
      btn.setAttribute('aria-expanded', 'true');
      $('.cc-acc-icon', btn).textContent = '−';
      document.getElementById(btn.getAttribute('aria-controls')).hidden = false;
    }
  }));
});

/* ====================== Christmas block: hide after its end date ====================== */
$$('[data-cc-xmas]').forEach((el) => {
  const end = Date.parse(el.getAttribute('data-end') || '');
  if (end && Date.now() > end) el.hidden = true;
});

/* ====================== Videos (iOS needs an explicit play) ====================== */
$$('.cc-page video').forEach((v) => {
  v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
  const p = v.play(); if (p && p.catch) p.catch(() => {});
});

/* ====================== Cart ====================== */
async function getCart() { return (await fetch(route('cart.js'), { headers: { Accept: 'application/json' } })).json(); }
async function cartPost(path, body, action, lines) {
  const deferred = CartLinesUpdateEvent.createPromise();
  try { document.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'product', lines: lines || [], promise: deferred.promise })); } catch (e) { /* theme may not listen here */ }
  try {
    const res = await fetch(route(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Erreur');
    const cart = await getCart();
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, source: 'chapitre-cafe' } });
    return cart;
  } catch (err) {
    deferred.resolve({ cart: null, detail: { didError: true } });
    throw err;
  }
}

const errorEl = $('[data-cc-error]');
async function addToCart() {
  if (!DATA) return;
  const buttons = $$('[data-cc-atc]');
  buttons.forEach((b) => b.setAttribute('aria-busy', 'true'));
  if (errorEl) errorEl.hidden = true;
  try {
    const b = DATA.bundles[state.bundle] || { qty: 1 };
    const items = [{ id: state.variant.id, quantity: b.qty }];
    const cart = await cartPost('cart/add.js', { items }, 'add', [{ merchandiseId: 'gid://shopify/ProductVariant/' + state.variant.id, quantity: b.qty }]);
    await openDrawer(cart);
  } catch (err) {
    if (errorEl) { errorEl.textContent = err.message || 'Impossible d’ajouter au panier.'; errorEl.hidden = false; }
  } finally {
    buttons.forEach((b) => b.removeAttribute('aria-busy'));
  }
}
$$('[data-cc-atc]').forEach((b) => b.addEventListener('click', addToCart));

/* ====================== Drawer ====================== */
const drawer = $('[data-cc-drawer]');
const D = drawer ? drawer.dataset : {};
let lastFocus = null;

function el(tag, cls, text) { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
function imgUrl(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
function isMug(item) { return DATA && item.product_id === DATA.productId; }
function modelOf(item) {
  const opt = item.options_with_values && item.options_with_values[0] ? item.options_with_values[0].value : (item.variant_title || '').split(' / ')[0];
  return opt || '';
}

async function changeLine(key, quantity) {
  const panel = $('.cc-panel', drawer);
  panel.classList.add('cc-d-busy');
  try { await renderCart(await cartPost('cart/change.js', { id: key, quantity: Math.max(0, quantity) }, 'change')); }
  catch (e) { /* keep drawer as is */ }
  finally { panel.classList.remove('cc-d-busy'); }
}

function lineEl(item) {
  const mug = isMug(item);
  const row = el('div', 'cc-line');
  const imgBox = el('div', 'cc-line-img');
  if (item.image) { const img = el('img'); img.src = imgUrl(item.image, 200); img.alt = ''; img.width = 84; img.height = 84; img.loading = 'lazy'; imgBox.appendChild(img); }
  const main = el('div', 'cc-line-main');
  const top = el('div', 'cc-line-top');
  const name = el('span', 'cc-line-name', mug ? DATA.productName : item.product_title);
  const sub = mug ? DATA.modelWord + ' ' + modelOf(item) : (item.variant_title || '');
  if (sub) name.appendChild(el('em', null, sub));
  top.append(name, el('span', 'cc-line-total', fmt(item.final_line_price)));
  main.appendChild(top);
  const v = mug ? variantById(item.variant_id) : null;
  const compare = v ? v.compare * item.quantity : item.original_line_price;
  const subRow = el('div', 'cc-line-sub');
  const b = mug ? bundleForQty(item.quantity) : null;
  subRow.appendChild(el('span', null, b ? b.title : (mug ? item.quantity + ' ' + (item.quantity > 1 ? DATA.unitWordPlural : DATA.unitWord) : '')));
  subRow.appendChild(el('s', null, compare > item.final_line_price ? fmt(compare) : ''));
  main.appendChild(subRow);
  const ctrl = el('div', 'cc-line-ctrl');
  const step = el('div', 'cc-stepper');
  const dec = el('button', null, '−'); dec.type = 'button'; dec.setAttribute('aria-label', 'Retirer un');
  const qty = el('span', null, String(item.quantity));
  const inc = el('button', null, '+'); inc.type = 'button'; inc.setAttribute('aria-label', 'Ajouter un');
  dec.addEventListener('click', () => changeLine(item.key, item.quantity - 1));
  inc.addEventListener('click', () => changeLine(item.key, item.quantity + 1));
  step.append(dec, qty, inc);
  const rm = el('button', 'cc-remove', D.remove || 'Supprimer'); rm.type = 'button';
  rm.addEventListener('click', () => changeLine(item.key, 0));
  ctrl.append(step, rm);
  main.appendChild(ctrl);
  row.append(imgBox, main);
  return row;
}

async function renderCart(cartIn) {
  if (!drawer) return;
  const cart = cartIn || await getCart();
  const items = cart.items;
  const mugLines = items.filter(isMug);
  const mugs = mugLines.reduce((a, it) => a + it.quantity, 0);
  $$('[data-cc-count]').forEach((n) => { n.textContent = String(mugs); });
  const countLabel = cart.item_count === 0 ? D.countNone : mugs === 1 && cart.item_count === 1 ? D.countOne : fill(D.countMany, { n: String(mugs || cart.item_count) });
  $('[data-cc-count-label]', drawer).textContent = countLabel;
  $('[data-cc-empty]', drawer).hidden = items.length > 0;
  $('[data-cc-foot]', drawer).hidden = items.length === 0;

  const wrap = $('[data-cc-lines]', drawer);
  wrap.textContent = '';
  items.forEach((it) => wrap.appendChild(lineEl(it)));

  // Upsell: exactly one single mug in the cart -> Édition double, same model
  const up = $('[data-cc-upsell]', drawer);
  up.hidden = true;
  if (DATA && mugLines.length === 1 && mugs === 1 && bundleForQty(2)) {
    const v = variantById(mugLines[0].variant_id) || state.variant;
    $('[data-cc-upsell-text]', up).textContent = fill(D.upsellLabel, { ecart: fmt(priceForQty(2, v) - priceForQty(1, v)) });
    up.onclick = () => changeLine(mugLines[0].key, 2);
    up.hidden = false;
  }

  let compareTotal = 0;
  items.forEach((it) => {
    const v = isMug(it) ? variantById(it.variant_id) : null;
    compareTotal += v ? Math.max(v.compare * it.quantity, it.final_line_price) : Math.max(it.original_line_price, it.final_line_price);
  });
  const save = compareTotal - cart.total_price;
  $('[data-cc-save-row]', drawer).hidden = !(save > 0);
  $('[data-cc-save]', drawer).textContent = fmt(save);
  $('[data-cc-total]', drawer).textContent = fmt(cart.total_price);
  return cart;
}

async function openDrawer(cart) {
  if (!drawer) return;
  lastFocus = document.activeElement;
  await renderCart(cart);
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.documentElement.style.overflow = 'hidden';
  setSticky(false);
  $('.cc-panel', drawer).focus({ preventScroll: true });
}
function closeDrawer() {
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.documentElement.style.overflow = '';
  if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  updateSticky();
}
if (drawer) {
  $$('[data-cc-close]', drawer).forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  // Header "Panier" and the theme's own cart triggers open THIS drawer (one cart UI per page).
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-cc-open-cart], [data-testid="cart-drawer-trigger"], a[href$="/cart"]');
    if (!t || drawer.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  }, true);
}

/* ====================== Sticky bar ====================== */
const sticky = $('[data-cc-sticky]');
const mainAtc = $('[data-cc-main-atc]');
let pastAtc = false;
function setSticky(on) {
  if (!sticky) return;
  sticky.classList.toggle('is-visible', on);
  sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
  $$('[data-cc-atc]', sticky).forEach((b) => { b.tabIndex = on ? 0 : -1; });
}
function updateSticky() { setSticky(pastAtc && !(drawer && drawer.classList.contains('is-open'))); }
if (sticky && mainAtc) {
  const onScroll = () => {
    const past = mainAtc.getBoundingClientRect().bottom < 0;
    if (past !== pastAtc) { pastAtc = past; updateSticky(); }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
}

/* ====================== Init ====================== */
if (DATA) {
  const params = new URLSearchParams(location.search);
  const fromUrl = variantById(Number(params.get('variant')));
  if (fromUrl) { state.variant = fromUrl; showVariantPhoto(fromUrl); } else { showPhoto(0); }
  render();
}
